import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { AuthService } from '../../../../../services/auth.service';
import { ComplianceReportingType } from '../../../../models/compliance.model';

@Component({
    selector: 'app-received-dates',
    templateUrl: './received-dates.component.html',
    styleUrls: ['./received-dates.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class ReceivedDatesComponent extends ApplicationSectionBaseComponent implements OnInit {

    @Input() form: FormGroup;
    @Input() reportType: ComplianceReportingType;
    @Input() application: WorkflowData;

    get formReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('formReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get cementTickReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('cementTickReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get safetySheetReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('safetySheetReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get cementLogReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('cementLogReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get prGraphReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('prGraphReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get stimInvoiceDateReceived(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('stimInvoiceDateReceived');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get stimRecordReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('stimRecordReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get stimLogReceivedDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('stimLogReceivedDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }

    get isInternal(): boolean {
        return this._auth.User.isInternal;
    }

    reviewStates: ApplicationState[] = [
        ApplicationState.VerifyCompletion,
        ApplicationState.InitialReview,
        ApplicationState.InitialApproval,
        ApplicationState.FinalApproval
    ];


    constructor(public _auth: AuthService) {
        super(_auth);

    }

    ngOnInit() {
        if (this.application != null) {
            if (this.isInternal) {
            this.form.get("stimLogReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|stimLogReceivedDate').dateData);
            this.form.get("stimRecordReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|stimRecordReceivedDate').dateData);
            this.form.get("stimInvoiceDateReceived").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|stimInvoiceDateReceived').dateData);
            this.form.get("prGraphReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|prGraphReceivedDate').dateData);

            }

            this.form.get("cementLogReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|cementLogReceivedDate').dateData);

            this.form.get("safetySheetReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|safetySheetReceivedDate').dateData);
            this.form.get("cementTickReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|cementTickReceivedDate').dateData);
            this.form.get("formReceivedDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'receivedDates|formReceivedDate').dateData);





        }

      
    }

    onDateUpdated(date: Date, field: string): void {
        let ctrl = this.form.get(field);
        if (ctrl != null) ctrl.setValue(date);
    }


}
